  //console.log('terplytics listener active');
  document.addEventListener('DOMContentLoaded', function () {
    let scrollPosition = 0;
    const hiddenContent = document.getElementById('hidden-content');
    hiddenContent.setAttribute('aria-hidden', 'true');

    document.getElementById('terplytics-open').addEventListener('click', function () {
      scrollPosition = window.pageYOffset;
      hiddenContent.classList.add('open');
      hiddenContent.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      document.body.style.top = `-${scrollPosition}px`;
      setTimeout(() => {
        document.getElementById('terp-modal-inner').classList.add('visible');
      }, 350);
    });

    document.querySelectorAll('#hidden-content-close, #hidden-content').forEach(element => {
      element.addEventListener('click', function(e) {
        if (this.id === 'hidden-content' && e.target !== this) return;
        hiddenContent.classList.add('wrap-inter');
        document.getElementById('terp-modal-inner').classList.add('inner-inter');
        setTimeout(() => {
          hiddenContent.classList.remove('open', 'wrap-inter');
          hiddenContent.setAttribute('aria-hidden', 'true');
          document.getElementById('terp-modal-inner').classList.remove('visible', 'inner-inter');
        }, 1200);
        document.body.classList.remove('no-scroll');
        document.body.style.top = '';
        window.scrollTo({
          top: scrollPosition,
          behavior: 'instant'
        });
      });
    });
  });
